const GenericAuthenticationTypesLabels = Object.freeze({
  none: 'Authentication_Type_None',
  basic: 'Authentication_Type_Basic',
  bearer: 'Authentication_Type_BearerToken',
  xapikey: 'Authentication_Type_XAPIKey',
  custom: 'Authentication_Type_Custom'
})

export { GenericAuthenticationTypesLabels }



// WEBPACK FOOTER //
// ./src/modules/channels/enum/AuthenticationTypesEnum.js